import { CobaltButton } from '@cae/cobalt-react/components/button';
import { CobaltLink } from '@cae/cobalt-react/components/link';
import { CobaltIconExternalLinkOutline } from '@cae/cobalt-react/icons/outline/CobaltIconExternalLinkOutline';
import { COMMON_TICKET_URL } from '@shared/utils/support-urls/supportUrls';
import * as React from 'react';

import type { BlockingDiscrepancyContentProps } from './BlockingDiscrepancyContent.types';

import { DiscrepancyIllustration } from '../illustrations/DiscrepancyIllustration';
import sharedStyles from '../shared/DiscrepancyLayout.module.css';

const BlockingDiscrepancyContent = React.memo(
  ({
    title,
    children,
    onGoHome,
  }: Readonly<BlockingDiscrepancyContentProps>): React.ReactElement => {
    return (
      <div
        className={sharedStyles.discrepancyPage}
        data-testid="blocking-discrepancy-content"
      >
        <DiscrepancyIllustration />

        <section
          className={sharedStyles.contentSection}
          aria-labelledby="blocking-discrepancy-title"
        >
          <h1 className="heading-02" id="blocking-discrepancy-title">
            {title}
          </h1>

          <div className={sharedStyles.contentFooter}>{children}</div>
        </section>

        <div className={sharedStyles.actions}>
          <CobaltLink href={COMMON_TICKET_URL} target="_blank">
            <CobaltButton type="button" variant="primary">
              Open a ticket
              <CobaltIconExternalLinkOutline />
            </CobaltButton>
          </CobaltLink>
          <CobaltButton type="button" variant="ghost" onClick={onGoHome}>
            Go to Homepage
          </CobaltButton>
        </div>
      </div>
    );
  }
);

BlockingDiscrepancyContent.displayName = 'BlockingDiscrepancyContent';

export { BlockingDiscrepancyContent };
